import React, { useEffect, useState } from "react";
import axios from "axios";
import { obtenerProgreso } from "../Pages/constants";
import "./ContenedorProgreso.css";
import { useData } from '../Pages/DataContext';


const ContenedorProgreso = ({  titulo = "Avance del curso" }) => {
  const { dataClase } = useData(); 
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  
    const idClase = dataClase?.id_clase || null;


useEffect(() => {
  const fetchProgreso = async () => {
    if (!idClase) {
      console.warn("⚠️ No se recibió idClase desde DataContext");
      setErrorMsg("No se encontró clase seleccionada");
      setLoading(false);
      return;
    }

    try {
      const url = obtenerProgreso(idClase);
      console.log("🔎 Consultando progreso en:", url);
      const res = await axios.get(url);

      if (res.data.success) {
        setProgress(res.data.progreso);
        setErrorMsg("");
      } else {
        setErrorMsg(res.data.message || "No se pudo obtener progreso");
      }
    } catch (err) {
      if (err.response) {
        setErrorMsg(
          `Error ${err.response.status}: ${err.response.data.error || "Problema en el servidor"}`
        );
      } else if (err.request) {
        setErrorMsg("El servidor no respondió. Revisa tu conexión.");
      } else {
        setErrorMsg("Error inesperado al obtener progreso.");
      }
    } finally {
      setLoading(false);
    }
  };

  fetchProgreso();
}, [idClase]);

  return (
    <div className="progreso-wrapper">
      <span className="progreso-label">{titulo}</span>

      <div className="progreso-barra">
        <div
          className="progreso-barra-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      {loading ? (
        <span className="progreso-valor">Cargando...</span>
      ) : errorMsg ? (
        <span className="progreso-error">{errorMsg}</span>
      ) : (
        <span className="progreso-valor">{progress}%</span>
      )}
    </div>
  );
};

export default ContenedorProgreso;
